/* eslint-disable react/display-name */
import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../../common';
import { getNext12HoursForecast } from '../../../../common/actions/hourlyForecastPageViewActions';
import { translate } from '../../../../common/translation/translate';
import { mediumMediaQuery, smallMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';
import { IHourlyForecastPeriod } from '../../common/types';
import { forecastViewScrollHandler, hourlyForecastScrollableViewId, largeHourlyForecastViewId, hourlyForecastCardBaseId } from '../../common/utils';

interface Next12HoursProps {
    apiHourlyForecastPeriods: IHourlyForecastPeriod[];
    hourlyForecastPeriods: IHourlyForecastPeriod[];
    isMobile: boolean;
    isTablet: boolean;
    getNext12HoursForecast(): void;
}

const mapStoreStateToProps = (storeState: any) => {
    const { hourlyForecastPage } =  storeState || {};
    const { hourlyForecastPeriods, apiHourlyForecastPeriods } = hourlyForecastPage || {};

    return {
        apiHourlyForecastPeriods,
        hourlyForecastPeriods
    };
};

const mapDispatchToProps = {
    getNext12HoursForecast
};

export const Next12Hours = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    apiHourlyForecastPeriods = [],
    hourlyForecastPeriods = [],
    isMobile,
    isTablet,
    getNext12HoursForecast }: Next12HoursProps) => {

    if (apiHourlyForecastPeriods?.length && hourlyForecastPeriods?.length && apiHourlyForecastPeriods?.length === hourlyForecastPeriods?.length
    || !apiHourlyForecastPeriods?.length) {
        return null;
    }

    const handleClick = useCallback(() => {
        if (apiHourlyForecastPeriods?.length) {
            if (hourlyForecastPeriods?.length) {

                getNext12HoursForecast();
                
                if (!isMobile) {
                    const scrollableContainerElement: HTMLElement | null = document.getElementById(hourlyForecastScrollableViewId);
                    const hourlyViewElement: HTMLElement | null = document.getElementById(largeHourlyForecastViewId);
                    const scrollSpeed = 450;
                    if (scrollableContainerElement && hourlyViewElement) {
                        const updateOffset = isTablet ? 150 : 199;
                        const scrollTo = Math.ceil(hourlyViewElement.scrollWidth + 1) - updateOffset;
                        forecastViewScrollHandler(scrollableContainerElement, scrollSpeed, scrollTo);
                    }
                }
            }
        }
    }, [apiHourlyForecastPeriods, hourlyForecastPeriods, isMobile, isTablet]);

    return (
        <Container onClick={handleClick} id={hourlyForecastCardBaseId}>
            <NextWrapper>
                {translate('next12Hours')}
            </NextWrapper>
        </Container>
    );
})));

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 260px;
    padding: 0 50px 0 20px;
    width: 190px;
    @media ${mediumMediaQuery} {
        padding: 0 33px;
        width: 130px;
    }
    @media ${smallMediaQuery} {
        margin: 0;
        padding: 0;
        flex-direction: row;
        height: 63px;
        width: 100%;
    }
`;

const NextWrapper = styled.div`
    display: flex;
    padding: 12px 0;
    font-size: 16px;
    font-weight: 600;
    width: 87px;
    height: 87px;
    border-radius: 100%;
    color: #ffffff;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 2px solid rgba(255,255,255,0.5);
    background-color: transparent;
    transition: border-color .15s ease-in-out;
    padding: 0 15.5px;
    text-align: center;
    @media ${smallMediaQuery} {
        width: 100%;
        height: 48px;
        border-radius: 2px;
        margin-top: 10px;
    }
    &:hover {
        border-color: white;
    }
`;